import { useMutation, gql } from "@apollo/client"
import { REGION_FIELDS } from "./useQueryRegions"

const UPDATE_REGION_MUTATION = gql`
  ${REGION_FIELDS}
  mutation UpdateRegion($id: ID!, $name: String!) {
    updateRegion(id: $id, name: $name) {
      ...RegionFields
    }
  }
`

const useMutationUpdateRegion = () => useMutation(UPDATE_REGION_MUTATION)

export { useMutationUpdateRegion }
